import { getExcelProducts } from '../../_services/product.service';
import { downloadExcelFile } from '../../_utils/download_file.util';

export const downloadExcelEvent = async () => {
    let res = await getExcelProducts();
    if(!res.ok){
        throw new Error(res.error);
    }
    downloadExcelFile(res.data.bytes, 'ODOO PLANTILLA PRODUCTOS');
    
    return res;
}